// extracted by mini-css-extract-plugin
export default {"webhooksContainer":"webhooksPage_webhooksContainer__K3Bc4","webhookEntry":"webhooksPage_webhookEntry__MSOzG"};